import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackOpenChat } from './tracking';
import { getNewbuildingChatSrc } from './utils';
import { closeChat } from 'shared/actions/chat';
import { IAppState } from 'shared/common/state';
import { ChatPopup } from 'shared/components/ChatPopup';
import { usePrevious } from 'shared/hooks/usePrevious';
import { selectSource } from 'shared/selectors';
import { getNewbuildingInformation } from 'shared/selectors/newbuildingHeader';
import { selectNewbuildingLayoutDetailsModalOpen } from 'shared/selectors/newbuildingLayouts';
import { selectChat } from 'shared/selectors/selectChat';
import { IDeveloperInfoRedesigned } from 'shared/types/developerInfo';
import { INewbuilding } from 'shared/types/newbuildingHeader';

import type { TContactParam } from '@cian/newbuilding-chat-component';

export const NewbuildingChatPopupContainer: React.FC = () => {
  const dispatch = useDispatch();

  const { isOpened, newbuildingContact, placeType } = useSelector(selectChat);
  const newbuilding = useSelector(getNewbuildingInformation) as INewbuilding | null;
  const developerInfoRedesigned = useSelector(
    (state: IAppState) => state.results.developerInfoRedesigned,
  ) as IDeveloperInfoRedesigned | null;
  const isLayoutDetailsModalOpen = useSelector(selectNewbuildingLayoutDetailsModalOpen);
  const source = useSelector(selectSource);
  const trackedProductId = newbuilding?.id ?? developerInfoRedesigned?.id ?? 0;

  const previousOpened = usePrevious(isOpened);

  React.useEffect(() => {
    if (!previousOpened && isOpened) {
      trackOpenChat({ newbuildingId: trackedProductId, placeType, source });
    }
  }, [previousOpened, isOpened, trackedProductId, placeType, source]);

  const onClose = React.useCallback(() => dispatch(closeChat()), [dispatch]);

  if (!isOpened) {
    return null;
  }

  const src = getNewbuildingChatSrc(newbuildingContact as TContactParam);

  return <ChatPopup src={src} onClose={onClose} aboveModal={isLayoutDetailsModalOpen} />;
};
